import { AlertTriangle, CloudUpload, FileDown, FileText, Loader2, RotateCcw, ShieldCheck } from 'lucide-react';
import { Barre } from './constantes';

const Compteur = ({ valeur, label, testId }) => (
  <div className="rounded-xl bg-white/10 px-4 py-3 backdrop-blur-sm">
    <p className="text-2xl font-bold" data-testid={testId}>{valeur}</p>
    <p className="text-xs text-white/60">{label}</p>
  </div>
);

const ETATS = {
  ok: [ShieldCheck, 'Enregistré sur votre compte', 'text-white/50'],
  en_cours: [Loader2, 'Enregistrement…', 'text-white/60'],
  erreur: [AlertTriangle, 'Non enregistré : vérifiez votre connexion', 'text-amber-300'],
  erreur_chargement: [AlertTriangle, 'Progression indisponible : rechargez la page', 'text-amber-300'],
};

const Sauvegarde = ({ etat }) => {
  const [Icone, label, couleur] = ETATS[etat] || ETATS.ok;
  return <span className={`inline-flex items-center gap-2 text-xs ${couleur}`} data-testid="guide-sauvegarde"><Icone className={`h-3.5 w-3.5 ${etat === 'en_cours' ? 'animate-spin' : ''}`} />{label}</span>;
};

const Bouton = ({ onClick, Icone, children, testId, plein }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-transform hover:-translate-y-0.5 ${plein ? 'bg-[#8DC63F] text-[#0F172A]' : 'border border-white/20 text-white/85 hover:bg-white/10'}`}>
    <Icone className="h-4 w-4" /> {children}
  </button>
);

export const EnteteGuide = ({ guide, global, progression, equipe, onReinitialiser, onPdf, onWord }) => (
  <header className="relative overflow-hidden bg-[#0F172A] text-white" data-testid="guide-entete">
    <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-[#0E7C74]/30 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-32 right-1/3 h-72 w-72 rounded-full bg-[#E2583E]/20 blur-3xl" />
    <div className="relative mx-auto max-w-6xl px-4 pb-10 pt-8 sm:px-6 sm:pt-12">
      <div className="flex items-center gap-3">
        <img src="/logo-fisl-transparent.png" alt="FISL" className="h-10 w-auto rounded-md bg-white p-1" />
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8DC63F]">{guide.diplome}</span>
      </div>
      <h1 className="mt-6 text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl animate-in fade-in slide-in-from-bottom-2 duration-700">{guide.titre}</h1>
      <p className="mt-4 max-w-2xl text-sm text-white/70 sm:text-base">
        Chaque critère et chaque indicateur expliqués, avec un exemple précis en motonautisme et disciplines associées (VNM, jet à bras, bouée tractée,
        eFoil, flyboard), les preuves à joindre et les questions du jury. Situez-vous sur chaque indicateur et préparez votre dossier au fur et à mesure.
      </p>
      <p className="mt-2 text-xs text-white/40">{guide.reference}</p>
      <div className="mt-8 grid max-w-2xl grid-cols-3 gap-3">
        <Compteur valeur={`${global.pret}/${global.total}`} label="indicateurs prêts" testId="guide-compteur-prets" />
        <Compteur valeur={global.enCours} label="en cours" testId="guide-compteur-en-cours" />
        <Compteur valeur={`${global.total ? Math.round((100 * global.pret) / global.total) : 0} %`} label="de la préparation" testId="guide-compteur-pourcent" />
      </div>
      <Barre pret={global.pret} total={global.total} couleur="bg-[#8DC63F]" className="mt-4 max-w-2xl bg-white/15" testId="guide-barre-globale" />
      <div className="mt-8 flex flex-wrap items-center gap-3">
        <Bouton onClick={onPdf} Icone={FileDown} testId="guide-telecharger-pdf" plein>Télécharger le guide PDF</Bouton>
        {guide.blocs.map((b) => (
          <Bouton key={b.code} onClick={() => onWord(b.code)} Icone={FileText} testId={`guide-word-${b.code}`}>
            {progression.lecture || equipe ? `Word ${b.code}` : `Mon brouillon ${b.code} (Word)`}
          </Bouton>
        ))}
        {!progression.lecture && <Bouton onClick={onReinitialiser} Icone={RotateCcw} testId="guide-reinitialiser">Recommencer</Bouton>}
        {!progression.lecture && <Sauvegarde etat={progression.sauvegarde} />}
        {progression.lecture && <span className="inline-flex items-center gap-2 text-xs text-white/50"><CloudUpload className="h-3.5 w-3.5" /> Lecture seule</span>}
      </div>
    </div>
  </header>
);
